<template>
  <va-create-layout>
    <contact-form :title="title" :item="item"></contact-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
